import { createAction, Dispatch } from '@reduxjs/toolkit';
import { SmscModel } from '../../models/smscModel';
import SmscApi from '../../api/smscApi';
import { AppError } from '../../types/appError';

export const smscFetchAllRequestAction = createAction<void>('smsc/fetchAllRequest');
export const smscFetchAllSuccessAction = createAction<SmscModel[]>('smsc/fetchAllSuccess');
export const smscFetchAllFailureAction = createAction<AppError>('smsc/fetchAllFailure');

export const fetchAllSmscByCommitId = (commitId: string) => async (dispatch: Dispatch) => {
  dispatch(smscFetchAllRequestAction());
  try {
    const allSmsc = await SmscApi.fetchAllSmscByCommitId(commitId);
    dispatch(smscFetchAllSuccessAction(allSmsc));
  } catch (error) {
    dispatch(smscFetchAllFailureAction(error as AppError));
  }
}
